module.exports = __webpack_public_path__ + "img/tui.325a3bbe.png";